export const FILING_GROUP = {
  FEDERAL: "FEDERAL",
  STATE: "STATE",
  OTHER: "OTHER",
} as const;

export type FilingGroup = (typeof FILING_GROUP)[keyof typeof FILING_GROUP];

export const FILING_GROUP_ORDER: FilingGroup[] = [
  FILING_GROUP.FEDERAL,
  FILING_GROUP.STATE,
  FILING_GROUP.OTHER,
];

export const FILING_GROUP_LABELS: Record<FilingGroup, string> = {
  [FILING_GROUP.FEDERAL]: "Federal tax filings",
  [FILING_GROUP.STATE]: "State filings",
  [FILING_GROUP.OTHER]: "Other filings",
};
